var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"outlined":"","items":_vm.items,"item-text":"text","item-value":"value","label":_vm.label,"persistent-hint":"","return-object":"","clearable":""},on:{"input":_vm.handleInput},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }